import { getFeatureFlag, isString } from "@sinch/feature-flags";
import { loadScript } from "../helpers/loadScript";

export const initGoogleTagManager = async () => {
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };

  const gtmId = getFeatureFlag("gtmId", isString, "null");
  if (!gtmId || gtmId === "null") {
    return console.error("Couldn't find a gtm Id");
  }

  gtag("js", new Date());
  gtag("config", gtmId);
  loadScript({
    src: `https://www.googletagmanager.com/gtm.js?id=${gtmId}`,
  });
};
